import { Record } from 'immutable'

export interface IAssociatedDevelopmentSite {
  readonly siteId: string
  readonly title: string
}

const AssociatedDevelopmentSiteRecord = Record({
  siteId: '',
  title: '',
})

export class AssociatedDevelopmentSite extends AssociatedDevelopmentSiteRecord
  implements IAssociatedDevelopmentSite {
  public static fromJS(initialState?: Partial<IAssociatedDevelopmentSite>) {
    if (!initialState) {
      return new AssociatedDevelopmentSite()
    }

    const { ...rest } = initialState

    return new AssociatedDevelopmentSite({
      ...rest,
    })
  }

  public readonly siteId: string
  public readonly title: string

  constructor(initialState?: Partial<AssociatedDevelopmentSite>) {
    initialState ? super(initialState) : super()
  }
}
